import React from 'react';
import RenderFooter from './RenderFooter';
const ReturnFooter = () => {
  return <RenderFooter />;
};

export default ReturnFooter;
